import Clarity from '@microsoft/clarity';

const clarityId = import.meta.env.VITE_APP_CLARITY_ID;

export const initClarity = () => {
  if (clarityId) {
    Clarity.init(clarityId);
    // Consent enables first-party cookies, required for session stitching in SPAs.
    // Without cookies, Clarity treats every URL change as a new session.
    Clarity.consent();
  }
};

export default Clarity;
